// Width of the main menu drawer (open, desktop). Anything laid out beside or inside the
// drawer -- the page's left margin, full-width bars fixed to the bottom of a page, the
// licensee selector -- reads it from here so they move together. 256 fits the longest labels
// ("Activity Categories", "Split OTA Bookings", "Web Chat Widget" plus its count badge) even
// when the menu shows its own scrollbar, which takes ~15px on Windows and Linux.
export const DRAWER_WIDTH = 256;
export const COLLAPSED_DRAWER_WIDTH = 65;
